import { render } from "./CreatePromotionModal.vue?vue&type=template&id=143351f0&scoped=true&ts=true"
import script from "./CreatePromotionModal.vue?vue&type=script&lang=ts"
export * from "./CreatePromotionModal.vue?vue&type=script&lang=ts"

import "./CreatePromotionModal.vue?vue&type=style&index=0&id=143351f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143351f0"]])

export default __exports__